<template>
  <div class="charts" v-loading="option._load" element-loading-background="rgba(9, 41, 84, 0.66)">
    <div class="charts_box" :style="{padding:config.border.show?`${config.border.width}px`:'0px'}">
      <!--图表-->
      <div :id="'screen_dom_'+option.id" v-show="!option._isError" v-if="!option.component" @click="chartDataId()">
      </div>
      <!--自定义组件   在这个里面，-->
      <component :is="option.component" :id="option.id" type="screen" v-show="!option._isError" :option="option.saveOption" :trans="option.trans" v-if="option.component"></component>
      <!--渲染失败-->
      <div class="charts_noData" v-show="option._isError">
        <p>渲染失败</p>
      </div>
    </div>
    <!--边框-->
    <borderChart :id="option.id" :option="option.saveOption"></borderChart>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/5/17 5:03 下午
 */
import borderChart from './borderChart.vue'

export default {
  name: 'charts',
  components: {
    borderChart
  },
  props: {
    option: {
      type: Object,
      default: {}
    },
  },
  computed: {
    config() {
      return this.option.saveOption.comConfig;
    },
  },
  data() {
    return {
      optionId: "",
      webId: "",
      viewId: "",
    }
  },
  methods: {
    chartDataId() {
      this.optionId = this.option.id
      this.webId = this.option.id
      this.viewId = this.option.viewDP.viewId
      this.$emit("handleClickData2", this.webId)
      this.$emit("handleClickData4", this.viewId)
    },
  },
  mounted() {

  },
  destroyed() {

  }
}
</script>

<style lang="less">
.charts {
  width: 100%;
  height: 100%;
  position: relative;

  .borderChart {
    z-index: 0 !important;
  }

  .charts_box {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1 !important;

    > div {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
